import PolarisIcon from '@/components/_common/PolarisIcon';
import { Button } from '@mui/material';
import React from 'react';
import { OrderJobAsset } from '../../../redux/slices/slice_types';
import LinkAssetSelectionModal from './LinkAssetSelectionModal';
import { selectCanLinkNewAsset } from '@/redux/selectors/authSelectors';
import { useAppDispatch, useAppSelector } from '@/redux/hooks';
import { applyFilter, clearFilters, setCurrentTable } from '@/redux/slices/dataTableSlice';
import { useHistory } from 'react-router-dom';
import { setLastOpenedPendingAssetLocation } from '@/redux/slices/fileManagerSlice';

interface LinkAssetProps {
  data: OrderJobAsset;
  disabled: boolean;
  path?: string;
}

const LinkAsset = ({ data, disabled, path }: LinkAssetProps) => {
  const dispatch = useAppDispatch();
  const history = useHistory();
  const [open, setOpen] = React.useState(false);
  const canLinkNewAsset = useAppSelector(selectCanLinkNewAsset);

  const onButtonClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    if (path) {
      dispatch(setLastOpenedPendingAssetLocation(path.split('/')));
    }
    setOpen(true);
  };

  const handleIngestRecordClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    if (data.ingest_record) {
      dispatch(setCurrentTable('fileIngest'));
      dispatch(clearFilters());
      dispatch(applyFilter({ type: 'ingest_hid_filter', selections: ['R' + data.ingest_record.toString()] }));
      history.push('/ingest-management');
    } else if (data.ingest_record_id) {
      history.push('/ingest-management/' + data.ingest_record_id);
    }
  };

  if (data.ingest_record || data.ingest_record_id) {
    return (
      <Button
        variant="outlined"
        color="secondary"
        onClick={handleIngestRecordClick}
        endIcon={<PolarisIcon icon="right" />}
        style={{ whiteSpace: 'nowrap', width: '100%' }}
      >
        Ingest Record
      </Button>
    );
  }
  return (
    <div>
      <Button
        color="primary"
        disabled={disabled || !canLinkNewAsset}
        variant={disabled ? 'outlined' : 'contained'}
        onClick={onButtonClick}
        sx={{ whiteSpace: 'nowrap', width: '100%' }}
        endIcon={<PolarisIcon icon="link" />}
      >
        Link Files
      </Button>

      {open && <LinkAssetSelectionModal data={data} onClose={() => setOpen(false)} />}
    </div>
  );
};
export default LinkAsset;
